import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Stack,
  InputAdornment,
  Chip,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import { extractCategories } from "../utils";

/**
 * Componente de filtros y buscador de inventario - Rediseñado
 */
const InventoryFilters = ({
  products,
  filterCategory,
  setFilterCategory,
  search,
  setSearch,
}) => {
  const categories = extractCategories(products);

  return (
    <Stack spacing={2}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <FilterListIcon color="action" fontSize="small" />
        <Typography variant="subtitle2" fontWeight={600} color="text.secondary">
          Filtros y Búsqueda
        </Typography>
        <Chip 
          label={`${products.length} artículos`} 
          size="small" 
          color="primary" 
          variant="outlined"
        />
      </Stack>

      <Stack direction="row" spacing={2} alignItems="center">
        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel>Filtrar por Categoría</InputLabel>
          <Select
            value={filterCategory}
            label="Filtrar por Categoría"
            onChange={(e) => setFilterCategory(e.target.value)}
          >
            {categories.map((c) => (
              <MenuItem key={c} value={c}>
                {c === "all" ? "📦 Todas las Categorías" : `📁 ${c}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          size="small"
          placeholder="Buscar por nombre, SKU, categoría o marca..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ flex: 1, minWidth: 300 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
        />
      </Stack>
    </Stack>
  );
};

export default InventoryFilters;

